module.exports = __webpack_public_path__ + "static/image/service/pc/one.ver2_0_2.jpg?50ce6d5c";